// extracted by mini-css-extract-plugin
module.exports = {"markersPanel":"styles_markersPanel__3mPmD"};